@if (bookingConstraints) {
  <div class="dialog-root-fix">
    <h2 mat-dialog-title>{{"restrict_booking_times.title" | transloco}}</h2>

    <mat-dialog-content class="column-flex">
      <p>{{"restrict_booking_times.info" | transloco}}</p>

      @for (weekDay of [1, 2, 3, 4, 5, 6, 0]; track $index) {
        <div class="row-flex">
          <div class="column-fixed">
            {{ weekDay | weekDay }}
          </div>

          <div class="row-wrap-flex">
            @for (bookingConstraint of bookingConstraintsWeekday(weekDay); track $index) {
              <div class="row-card">
                <mat-form-field subscriptSizing="dynamic" class="width-medium">
                  <input matInput [(ngModel)]="bookingConstraint.startTimeMinutesAfterMidnight">
                </mat-form-field>

                <p>-</p>

                <mat-form-field subscriptSizing="dynamic" class="width-medium">
                  <input matInput [(ngModel)]="bookingConstraint.endTimeMinutesAfterMidnight">
                </mat-form-field>

                <button mat-icon-button (click)="deleteBookingConstraint(bookingConstraint)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>

          <button mat-icon-button (click)="addBookingConstraint(weekDay)">
            <mat-icon>add</mat-icon>
          </button>

          <button mat-icon-button (click)="copyBookingConstraints(weekDay)">
            <mat-icon>content_copy</mat-icon>
          </button>

          <button mat-icon-button (click)="pasteBookingConstraints(weekDay)">
            <mat-icon>content_paste</mat-icon>
          </button>

          <button mat-icon-button (click)="deleteBookingContraints(weekDay)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }

      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button type="button" (click)="close()">{{ "button.cancel" | transloco }}</button>
      <button mat-flat-button (click)="save()">{{ "button.save" | transloco }}</button>
    </mat-dialog-actions>
  </div>
}
